import type { EstadoTrabajo } from '@laser/core';
import { pesos } from './formato';
import { fechaCorta } from './fechas';

export type PlantillaWhatsApp = 'cotizacion' | 'en_cola' | 'listo' | 'general';

export interface DatosMensaje {
  nombre: string;
  folio: string;
  totalCentavos: number | null;
  pagoUrl?: string | null;
  fechaCompromiso?: string | null;
}

export const ETIQUETA_PLANTILLA: Record<PlantillaWhatsApp, string> = {
  cotizacion: 'Cotización lista',
  en_cola: 'En cola',
  listo: 'Listo para recoger',
  general: 'Mensaje',
};

/** Teléfono como lo capturó el cliente → dígitos para wa.me (10 dígitos MX → 52…). */
export function telefonoWhatsApp(telefono: string): string {
  let d = (telefono || '').replace(/\D/g, '');
  if (d.startsWith('00')) d = d.slice(2);
  if (d.length === 10) d = '52' + d;
  // Formato viejo de celular MX: 521 + 10 dígitos.
  if (d.length === 13 && d.startsWith('521')) d = '52' + d.slice(3);
  return d;
}

const primerNombre = (n: string) => (n || '').trim().split(/\s+/)[0] || '';

export function mensajeWhatsApp(plantilla: PlantillaWhatsApp, d: DatosMensaje): string {
  const hola = `Hola ${primerNombre(d.nombre)}`.trim();
  const folio = d.folio;
  switch (plantilla) {
    case 'cotizacion': {
      const total = d.totalCentavos != null ? ` El total es de ${pesos(d.totalCentavos)} MXN.` : '';
      const pago = d.pagoUrl ? ` Puedes pagar aquí: ${d.pagoUrl}` : ' En un momento te mandamos el link de pago.';
      return `${hola}, te escribimos de Emisha Láser. Tu cotización ${folio} ya está lista.${total}${pago} En cuanto se registre el pago lo metemos a la cola de corte.`;
    }
    case 'en_cola': {
      const cuando = d.fechaCompromiso ? ` Calculamos tenerlo listo el ${fechaCorta(d.fechaCompromiso)}.` : '';
      return `${hola}, recibimos tu pago del trabajo ${folio} y ya está en la cola de corte.${cuando} Te avisamos por aquí en cuanto esté listo.`;
    }
    case 'listo':
      return `${hola}, tu trabajo ${folio} ya está listo para recoger en el taller de Emisha. Cuando vengas, menciona el folio ${folio}. ¡Gracias!`;
    case 'general':
    default:
      return `${hola}, te escribimos de Emisha Láser sobre tu trabajo ${folio}.`;
  }
}

/** Plantilla que conviene sugerir según el estado del trabajo. */
export function plantillaSugerida(estado: EstadoTrabajo): PlantillaWhatsApp {
  if (estado === 'cotizado' || estado === 'en_revision' || estado === 'recibido') return 'cotizacion';
  if (estado === 'pagado' || estado === 'en_cola' || estado === 'cortando') return 'en_cola';
  if (estado === 'listo') return 'listo';
  return 'general';
}

export function enlaceWhatsApp(telefono: string, mensaje: string): string {
  return `https://wa.me/${telefonoWhatsApp(telefono)}?text=${encodeURIComponent(mensaje)}`;
}
